<ng-template #editSubCategoryKeywordModal>
  <div class="p-5">
    <div>Keywords for {{keywordsSelectedSubCategory.label}}</div>
    <div class="d-flex flex-wrap mb-4">
      <button *ngFor="let keyword of keywordSSelectedSubCategoryKeywordList" class="btn btn-sm btn-outline-primary mt-2 mr-2">
        {{keyword}}  <i class="fa fa-x" style="font-size: .7rem;" (click)="removeKeywordFromSelectedSubCategory(keyword)"></i>
      </button>
    </div>
    <div class="mb-2 mx-2 d-flex w-100">
      <input type="text" placeholder="new keyword to add" [(ngModel)] ="currentInputtingKeyword" class="form-control" />
      <button class="my-button-3 ml-2" (click)="addKeywordToSelectedSubCategory()">Add</button>
    </div>
    <p style="font-weight: bold;">Suggestions Based On Types</p>
    <div class="d-flex flex-wrap">
      <span (click)=" currentInputtingKeyword = name" *ngFor="let name of selectedCategoryTypesNameSuggestion"  class="btn btn-sm btn-outline-primary mt-2 mr-2">
        {{name}}
      </span>

    </div>
  </div>


</ng-template>
<div class="side-left-menu" [class.active]="menuSliderLeft" #sideMenuWrapper>
  <div class="bg">
    <div class="side-left-menu__tabs">
      <div class="item" (click)="tabMenuLeft = false" [class.active-tab-chosse]="!tabMenuLeft">Info</div>
      <div class="item" (click)="tabMenuLeft = true" [class.active-tab-chosse]="tabMenuLeft">Browse</div>
    </div>

    <div class="side-left-menu__list my-category" [class.active-tab]="tabMenuLeft">
      <ng-container *ngFor="let item of menuItems">
        <div class="side-left-menu__list--item" *ngIf="item.title; else content">
          <i></i>
          <div class="title-tabs">{{ item.title }}</div>
        </div>
        <ng-template #content>
          <a class="side-left-menu__list--item" *ngIf="!item.subLinks" [routerLink]="item.routerLink" routerLinkActive="active-link">
            <i class="icon" [class]="item.iconClass"></i>
            <div class="text">{{ item.label }}</div>
          </a>
          <ng-container *ngIf="item.subLinks && item.collapseId">
            <a href="#{{ item.collapseId }}" data-toggle="collapse" aria-expanded="false" class="side-left-menu__list--item" [class.active-link-sub]="menuItem.label == item.label">
              <!-- <i class="icon" [class]="item.iconClass"></i> -->
              <img src="{{ imgUrl }}{{ item.image }}" alt="" />
              <div class="text">{{ item.label }} <i *ngIf="item.subLinks.length" class="fa-solid fa-angle-right"></i></div>
            </a>
            <div *ngIf="item.subLinks.length" [id]="item.collapseId" class="collapse" routerLinkActive="show">
              <ng-container *ngFor="let subItem of item.subLinks">
                <div class="d-flex collapse__item justify-content-center">
                  <a [routerLink]="subItem.routerLink" class="" routerLinkActive="active">
                    <!-- <i class="icon" [class]="subItem.iconClass"></i> -->
                    <i></i>
                    <div class="text">{{ subItem.label }} 
                    
                    </div>
                      
                    <ng-container *ngFor="let sub of subItem.subText">
                      <span class="sub-text" *ngIf="sub.condition">
                        {{ sub.text }}
                      </span>
                     
                    </ng-container>
                    
                  </a>
                  <button (click)="$event.stopPropagation(); openEditSubCategoryKeywordModal(subItem)"  class="t-btn ml-2">
                    <i class="fa fa-pen" style="font-size: .8rem;" *ngIf="isAdmin"></i> 
                  </button>
                </div>
                
                <a *ngIf="subItem.externalLink" [href]="subItem.externalLink" target="_blank" class="side-left-menu__list--item">
                  <i class="icon" [class]="subItem.iconClass"></i>
                  <div class="text">{{ subItem.label }}</div>
                </a>
              </ng-container>
            </div>
          </ng-container>
        </ng-template>
      </ng-container>
    </div>
    <div class="side-left-menu__list my-info" [class.active-tab]="!tabMenuLeft">
      <ng-container *ngFor="let item of menuItemsInfo">
        @if(item.title) { @if(item.condition) {
        <div class="side-left-menu__list--item">
          <i></i>
          <div class="title-tabs">{{ item.title }}</div>
        </div>
        } } @else {
        <ng-container *ngIf="!item.subLinks">
          <ng-container *ngIf="item.condition">
            <a class="side-left-menu__list--item" *ngIf="item.routerLink" [routerLink]="item.routerLink" routerLinkActive="active-link">
              <i class="icon" [class]="item.iconClass"></i>
              <div class="text">{{ item.label }}</div>
            </a>
            <div class="side-left-menu__list--item" *ngIf="!item.routerLink" (click)="item.myclick()">
              <i class="icon" [class]="item.iconClass"></i>
              <div class="text">{{ item.label }}</div>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="item.subLinks && item.collapseId">
          <a href="#{{ item.collapseId }}" data-toggle="collapse" aria-expanded="false" class="side-left-menu__list--item" [class.active-link-sub]="menuItem.label == item.label">
            <i class="icon" [class]="item.iconClass"></i>
            <div class="text">{{ item.label }} <i *ngIf="item.subLinks.length" class="fa-solid fa-angle-right"></i></div>
          </a>
          <div *ngIf="item.subLinks.length" [id]="item.collapseId" class="collapse" routerLinkActive="show">
            <ng-container *ngFor="let subItem of item.subLinks">
              <a [routerLink]="subItem.routerLink" class="side-left-menu__list--item" routerLinkActive="active">
                <i></i>
                <div class="text">{{ subItem.label }}</div>
                <ng-container *ngFor="let sub of subItem.subText">
                  <span class="sub-text" *ngIf="sub.condition">
                    {{ sub.text }}
                  </span>
                </ng-container>
              </a>
              <a *ngIf="subItem.externalLink" [href]="subItem.externalLink" target="_blank" class="side-left-menu__list--item">
                <i class="icon" [class]="subItem.iconClass"></i>
                <div class="text">{{ subItem.label }}</div>
              </a>
            </ng-container>
          </div>
        </ng-container>
        }
      </ng-container>
    </div>
  </div>
</div>
